import { useEffect, useState } from 'react';
import { Input } from '../input/Input';
import styles from './AddressForm.module.css';


export type TAddress = {
  street: string;
  city: string;
  postcode: string;
};

interface TAddressFormProps {
  onChange: (newAddress: TAddress) => void;
}

export const AddressForm = ({ onChange }: TAddressFormProps) => {
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [postcode, setPostcode] = useState('');

  useEffect(
    () => onChange({ street, city, postcode }),
    [street, city, postcode, onChange]
  );

  return (
    <div className={styles.container}>
      <div className={styles.fieldGroup}>
        <label htmlFor="street" className={styles.label}>
          Street Address
        </label>
        <Input
          id="street"
          name="street"
          placeholder="e.g 8 Flint Street"
          value={street}
          onChange={(e) => setStreet(e.target.value)}
        />
      </div>

      <div className={styles.row}>
        <div className={styles.half}>
          <label htmlFor="city" className={styles.label}>
            City
          </label>
          <Input
            id="city"
            name="city"
            placeholder="e.g London"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>

        <div className={styles.half}>
          <label htmlFor="postcode" className={styles.label}>
            Postcode
          </label>
          <Input
            id="postcode"
            name="postcode"
            placeholder="e.g SW1 2AA"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
